import { render, staticRenderFns } from "./advisor-dashboard.vue?vue&type=template&id=7db610f8&scoped=true&"
import script from "./advisor-dashboard.vue?vue&type=script&lang=js&"
export * from "./advisor-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./advisor-dashboard.vue?vue&type=style&index=0&id=7db610f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db610f8",
  null
  
)

component.options.__file = "advisor-dashboard.vue"
export default component.exports